/**
 * Combina bloques SUMMARY_BY_DOCTOR de varias respuestas admin-data (p. ej. por mes).
 * @param {Array<Record<string, unknown>>} monthlyDataArray
 * @returns {Array<Record<string, unknown>>}
 */
export default function mergeSummaryByDoctor(monthlyDataArray) {
  if (!Array.isArray(monthlyDataArray)) return []

  const num = x => {
    const n = Number(x)
    return Number.isFinite(n) ? n : 0
  }

  const map = new Map()

  monthlyDataArray.forEach(m => {
    const arr = m?.SUMMARY_BY_DOCTOR
    if (!Array.isArray(arr)) return

    arr.forEach(row => {
      const rawId = row?.doctor_id
      if (rawId == null) return
      const key = Number(rawId)

      if (!map.has(key)) {
        map.set(key, {
          doctor_id: key,
          doctor_name: row.doctor_name || '',
          patients_count: 0,
          total_billed: 0,
          np_count: 0,
          nc_count: 0,
          np_30_count: 0,
          nc_30_count: 0,
          weighted_np_sum: 0,
          weighted_nc_sum: 0,
        })
      }

      const agg = map.get(key)
      if (row.doctor_name) agg.doctor_name = row.doctor_name

      const p = num(row.patients_count)
      const tb = num(row.total_billed)
      const npc = num(row.np_count)
      const ncc = num(row.nc_count)

      agg.patients_count += p
      agg.total_billed += tb
      agg.np_count += npc
      agg.nc_count += ncc
      agg.np_30_count += num(row.np_30_count)
      agg.nc_30_count += num(row.nc_30_count)
      agg.weighted_np_sum += num(row.avg_np) * npc
      agg.weighted_nc_sum += num(row.avg_nc) * ncc
    })
  })

  const out = Array.from(map.values()).map(a => ({
    doctor_id: a.doctor_id,
    doctor_name: a.doctor_name,
    patients_count: a.patients_count,
    total_billed: Math.round(a.total_billed * 100) / 100,
    avg_total:
      a.patients_count > 0
        ? Math.round((a.total_billed / a.patients_count) * 100) / 100
        : 0,
    np_count: a.np_count,
    avg_np: a.np_count > 0 ? Math.round((a.weighted_np_sum / a.np_count) * 100) / 100 : 0,
    nc_count: a.nc_count,
    avg_nc: a.nc_count > 0 ? Math.round((a.weighted_nc_sum / a.nc_count) * 100) / 100 : 0,
    np_30_count: a.np_30_count,
    nc_30_count: a.nc_30_count,
  }))

  out.sort((x, y) => String(x.doctor_name || '').localeCompare(String(y.doctor_name || '')))

  return out
}
